import React, { FC } from 'react';

import { Flex } from 'Src/components/layout/Flex';
import { HeaderMainNav } from 'Src/components/navigation/HeaderMainNav';
import { Page } from 'Src/feature/page/Page';
import { PageMain } from 'Src/feature/page/PageMain';
import { PageMainHeader } from 'Src/feature/page/PageMainHeader';

import Copy from './Copy';

const ComingSoonPage: FC = () => (
  <Page
    main={(
      <PageMain
        header={<PageMainHeader end={<HeaderMainNav />} />}
        main={(
          <Flex
            fullHeight
            alignItems="center"
            justifyContent="center"
          >
            <Copy variant="h1" color="warning" align="center" value="COMING SOON" />
          </Flex>
        )}
      />
    )}
  />
);

export default ComingSoonPage;
